var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batch-card-body"},[_c('p',{staticClass:"batch-card-body__title"},[_c('span',{class:{
        'open': _vm.stateName === 'Aberto',
        'closed': _vm.stateName === 'Completo'
      }},[_vm._v("\n      "+_vm._s(_vm.totalSamples)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"batch-card-body__subtitle"},[_vm._v("\n    AMOSTRA"),(_vm.totalSamples > 1)?_c('span',[_vm._v("S")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"batch-card-body__description"},[_c('span',{class:{
        'open': _vm.stateName === 'Aberto',
        'closed': _vm.stateName === 'Completo'
      }},[_vm._v("\n      "+_vm._s(_vm.stateName)+"\n    ")])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }